import Vue from 'vue';
import VueRouter from 'vue-router';
import Layout from '../pages/Layout';
import Login from "../pages/Login";
import List from "../pages/List";
import ViewModule from "../pages/ViewModule";

Vue.use(VueRouter)


const routes = [
    {
        path: '/',
        name: 'Layout',

        component: Layout,
        redirect: {name: "List"},
        children: [
            {
                path: "list/",
                name: "List",
                meta: {
                    isLogin: true,
                    active: "List"
                },
                component: List,
            },
            {
                path: "view",
                name: "View",
                meta: {
                    isLogin: true,
                    active: "View"
                },
                component: ViewModule
            },
        ],
    },
    {
        path: "/login",
        name: "Login",
        meta: {
            isLogin: false
        },
        component: Login
    },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    linkActiveClass: "active",
    linkExactActiveClass: "exact-active",
    routes
})

router.beforeEach((function (to, from, next) {
    if (to.meta.isLogin) {
        const jwt = localStorage.getItem("jwt");
        if (jwt) {
            next()
        } else {
            next("/login");
        }
    } else {
        next()
    }
}))


export default router
